



import StoreEditComponent from "@/components/admin/store/storeEditComponent.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "StoreEditPage",
  components: {
    StoreEditComponent,
  },
})
export default class StoreListPage extends Vue {}
